import React from 'react';
import { Icon } from '@iconify-icon/react';

const sources = [
  { icon: 'tabler:file-type-pdf', label: 'Policies' },
  { icon: 'tabler:brand-notion', label: 'Wikis' },
  { icon: 'tabler:folder', label: 'Drive' },
  { icon: 'tabler:message-2', label: 'SOPs' },
];

const CompanyBrainDiagram: React.FC = () => (
  <div className="relative mx-auto w-full max-w-md">
    {/* Source chips */}
    <div className="mb-4 grid grid-cols-4 gap-2">
      {sources.map((s) => (
        <div
          key={s.label}
          className="flex flex-col items-center gap-1.5 rounded-xl border border-gray-100 bg-white px-2 py-3 shadow-sm">
          <Icon icon={s.icon} className="text-lg text-primary-600" />
          <span className="text-[10px] font-semibold text-gray-600">{s.label}</span>
        </div>
      ))}
    </div>

    {/* Flow arrows */}
    <div className="mb-4 flex justify-center">
      <Icon icon="tabler:arrow-down" className="text-2xl text-primary-600/40" />
    </div>

    {/* Brain core */}
    <div className="relative overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-br from-[#04182e] to-primary-600 p-6 shadow-xl shadow-primary-600/20">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:1.5rem_1.5rem]" />
      <div className="relative flex items-center gap-3">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 backdrop-blur-sm">
          <Icon icon="tabler:brain" className="text-2xl text-[#d3a641]" />
        </span>
        <div>
          <div className="text-sm font-bold text-white">Company Brain</div>
          <div className="text-[11px] text-blue-200/70">Cited answers · Always current</div>
        </div>
      </div>
      <div className="relative mt-4 space-y-2">
        <div className="rounded-xl bg-white/10 px-3 py-2 backdrop-blur-sm">
          <div className="text-[10px] text-blue-100/60">Employee asks</div>
          <div className="mt-0.5 text-xs font-medium text-white">
            What&apos;s our remote work policy for contractors?
          </div>
        </div>
        <div className="rounded-xl bg-white px-3 py-2.5 shadow-sm">
          <div className="text-[11px] leading-snug text-gray-700">
            Contractors may work remotely up to 3 days/week with manager approval
            <sup className="font-bold text-primary-600"> 1</sup>.
          </div>
          <div className="mt-1.5 flex items-center gap-1 text-[9px] text-gray-400">
            <Icon icon="tabler:circle-check" className="text-[10px] text-emerald-500" />
            Cited · Employee Handbook, §4.2
          </div>
        </div>
      </div>
    </div>

    {/* Audience chips */}
    <div className="mt-4 flex justify-center">
      <Icon icon="tabler:arrow-down" className="text-2xl text-primary-600/40" />
    </div>
    <div className="mt-4 flex flex-wrap justify-center gap-2">
      {['HR', 'Ops', 'Sales', 'Legal', 'Support', 'New hires'].map((role) => (
        <span
          key={role}
          className="rounded-full border border-gray-200 bg-white px-3 py-1 text-[11px] font-semibold text-gray-700 shadow-sm">
          {role}
        </span>
      ))}
    </div>
  </div>
);

export default CompanyBrainDiagram;
